import { useEffect, useRef, useState } from "react";
import { errorToast } from "../react-toastfiy/toast";
import { isMobile } from "../helpers/functions/isMobile";

function SearchBoxWithCustomQuery(props) {
  const {
    allData,
    setFilteredData,
    placeholder = "Search...",
    return_array = false,
    setSearchOrDate = null,
    className = "",
    keysToSearchOn = [],
    useSearchBoxButton = false,
    showSearchBoxByDefault = false,
    // Optional: reports the raw (debounced) search text whenever it
    // changes, so a caller can send it to the backend — setFilteredData
    // alone only returns the locally-filtered rows, never the query itself.
    onQueryChange = null,
  } = props;
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchBox, setShowSearchBox] = useState(showSearchBoxByDefault);
  const inputRef = useRef(null);

  // Debounce function
  function debounce(func, delay) {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  }

  const getDataFromDataKey = (val, data_key) => {
    let keys = data_key.split(".");
    let value = val;
    for (const key of keys) {
      if (value && typeof value === "object" && key in value) {
        value = value[key];
      } else {
        return undefined; // Handle cases where the path doesn't exist
      }
    }
    return value;
  };

  // const handleSearchQueryChanged = (val, data) => {
  //   try {
  //     // Create a deep copy to avoid direct mutation of props
  //     let dataToFilter = structuredClone(data);
  //     let searchInput = val.toLowerCase();

  //     if (searchInput.length === 0) {
  //       setFilteredData(data); // If no query, return all data
  //       return;
  //     }

  //     const searchQueries = searchInput
  //       .split(" ")
  //       .filter((item) => item !== "");

  //     // If no valid search queries, return all data
  //     if (searchQueries.length === 0) {
  //       setFilteredData(data);
  //       return;
  //     }

  //     let scoredResults = Object.entries(dataToFilter)
  //       .map(([key, entry]) => {
  //         let score = 0;
  //         const matchedQueries = new Set(); // To count unique matched queries for scoring

  //         // Check if any search query matches any key to search on
  //         const isMatch = searchQueries.some((queryItem) => {
  //           queryItem = queryItem?.toString().toLowerCase();

  //           return keysToSearchOn?.some((key_to_search) => {
  //             const dataValue = entry;
  //             if (dataValue === undefined || dataValue === null) return false;

  //             const lowerCaseDataValue = dataValue.toString().toLowerCase();

  //             // Check for startsWith, endsWith, includes, and increment score
  //             if (lowerCaseDataValue.startsWith(queryItem)) {
  //               matchedQueries.add(queryItem);
  //               return true;
  //             }
  //             if (lowerCaseDataValue.endsWith(queryItem)) {
  //               matchedQueries.add(queryItem);
  //               return true;
  //             }
  //             if (lowerCaseDataValue.includes(queryItem)) {
  //               matchedQueries.add(queryItem);
  //               return true;
  //             }
  //             return false;
  //           });
  //         });

  //         if (isMatch) {
  //           score = matchedQueries.size; // Score is the number of unique search queries matched
  //           return { key, entry, score };
  //         }
  //         return null; // No match
  //       })
  //       .filter(Boolean); // Remove null entries

  //     // Sort by score in descending order (maximum match first)
  //     scoredResults.sort((a, b) => b.score - a.score);

  //     let results = {};
  //     if (return_array) {
  //       results = scoredResults.map((item) => item.entry);
  //     } else {
  //       scoredResults.forEach((item) => {
  //         results[item.key] = item.entry;
  //       });
  //     }

  //     setFilteredData(results);
  //   } catch (error) {
  //     console.error(error);
  //     // errorToast(error?.message); // Uncomment if errorToast is available
  //   }
  // };

  // const debouncedSearch = debounce(handleSearchQueryChanged, 300);

  // useEffect(() => {
  //   // Only call debouncedSearch if allData is available and not empty
  //   if (allData && Object.keys(allData).length > 0) {
  //     debouncedSearch(searchQuery, allData);
  //   } else {
  //     setFilteredData([]); // Clear filtered data if no allData
  //   }
  // }, [searchQuery, allData]); // Add allData to dependencies so search re-runs if it changes

  const handleSearchQueryChanged = (val, data) => {
    try {
      data = structuredClone(data);

      let searchInput = val.toLowerCase();

      if (searchInput.length === 0) {
        setFilteredData(allData);
        return;
      }

      const searchQueries = searchInput
        .split(" ")
        .filter((item) => item !== "");
      let results = Object.entries(data).filter(([key, entry]) => {
        return searchQueries.some((item) => {
          item = item?.toString().toLowerCase();

          return keysToSearchOn?.some((key_to_search) => {
            return (
              getDataFromDataKey(entry, key_to_search)
                ?.toString()
                ?.toLowerCase()
                ?.startsWith(item) ||
              getDataFromDataKey(entry, key_to_search)
                ?.toString()
                ?.toLowerCase()
                ?.endsWith(item) ||
              getDataFromDataKey(entry, key_to_search)
                ?.toString()
                ?.toLowerCase()
                ?.includes(item) ||
              key?.toString()?.toLowerCase()?.startsWith(item) ||
              key?.toString()?.toLowerCase()?.endsWith(item) ||
              key?.toString()?.toLowerCase()?.includes(item)
            );
          });
        });
      });
      results = Object.fromEntries(results);

      if (return_array) {
        results = Object.values(results);
      }
      setFilteredData(results);
    } catch (error) {
      console.error(error);
      errorToast(error?.message);
    }
  };

  const debouncedSearch = debounce(handleSearchQueryChanged, 300);

  useEffect(() => {
    handleSearchQueryChanged(searchQuery, allData);
  }, [searchQuery]);

  const onQueryChangeDebounceRef = useRef(null);
  useEffect(() => {
    if (!onQueryChange) return;
    if (onQueryChangeDebounceRef.current) clearTimeout(onQueryChangeDebounceRef.current);
    onQueryChangeDebounceRef.current = setTimeout(() => onQueryChange(searchQuery), 400);
    return () => clearTimeout(onQueryChangeDebounceRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  return (
    <>
      <div
        className={`d-flex justify-content-end align-items-center gap-2 ${
          useSearchBoxButton && showSearchBox ? (isMobile ? "col-12" : "") : ""
        }`}
      >
        {(useSearchBoxButton ? showSearchBox : true) && (
          <div className="search-input-container position-relative flex-grow-1">
            <input
              type="search"
              name="search-form"
              id="search-form"
              style={{ fontSize: "0.875rem" }}
              // Adjust padding-left to make space for the icon
              className={`form-control ps-5 ${className}`}
              placeholder={placeholder}
              ref={inputRef}
              onChange={(e) => {
                setSearchQuery(e.target.value.trimStart());
              }}
              value={searchQuery}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
            {/* Search icon */}
            <i className="bi bi-search search-icon position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
          </div>
        )}
        {useSearchBoxButton && (
          <button
            className={`btn bg-danger-subtle text-danger position-relative rounded-circle ${
              showSearchBox ? "border-danger" : ""
            }`}
            onClick={() => {
              setShowSearchBox((prev) => {
                if (!prev) setTimeout(() => inputRef.current?.focus(), 50);
                return !prev;
              });
              if (setSearchOrDate) {
                setSearchOrDate(false);
              }
            }}
          >
            <i className="bi bi-search"></i>
            {searchQuery && !showSearchBox && (
              <span className=" p-1 bg-danger position-absolute end-0 translate-middle rounded-circle"></span>
            )}
          </button>
        )}
      </div>
    </>
  );
}

export default SearchBoxWithCustomQuery;
